import { useEffect } from 'react';
// This converts our server errors to a format that react-hook-form understands
export function addServerError(error, setError) {
    setError(error.attribute, {
        // Rule Name
        message: error.details.join('. '),
        type: 'server',
    });
}
export const useServerErrorToFormError = ({ serverError, setError, }) => {
    useEffect(() => {
        if (serverError) {
            for (const key in serverError) {
                addServerError({ attribute: key, details: serverError[key] }, setError);
            }
        }
    }, [serverError, setError]);
};
